import type { PlayerData } from '../../components/PlayersStats/PlayersStats.types';

const sortCardPlayersData = (player1: PlayerData, player2: PlayerData) =>
  (player2.yellowCards || 0) - (player1.yellowCards || 0) ||
  (player2.redCards || 0) - (player1.redCards || 0);

export default sortCardPlayersData;
